import { logger } from '../../../utils/logger'
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, DestroyRef, inject } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { distinctUntilChanged, from, map, Observable, Subject, Subscribable, takeUntil } from 'rxjs'
import { ConcursosAtivos } from 'src/app/models/concursos-ativos'
import { ComissaoJulgadoraService } from '../comissao-julgadora-service'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

export interface ExaminadoresFiltro {
  concurso?: number
  papel?: string
  nome?: string
}

@Component({
  selector: 'inscricoes-listagem-examinadores-filtro',
  templateUrl: './listagem-examinadores-filtro.component.html',
  styleUrls: ['./listagem-examinadores-filtro.component.scss'],
})
export class ListagemExaminadoresFiltroComponent implements OnInit, OnChanges, OnDestroy {
  private destroyRef = inject(DestroyRef)

  @Input() initialFilters: ExaminadoresFiltro = {
    concurso: 0,
    papel: '',
    nome: '',
  }
  @Input() hideConcursoFilter = false

  @Output() filterChanged = new EventEmitter<ExaminadoresFiltro>()

  /** Auto-detecta se deve ocultar o filtro de concurso (quando já vem pré-selecionado via rota) */
  get shouldHideConcursoFilter(): boolean {
    return this.hideConcursoFilter || !!this.initialFilters.concurso
  }

  filterForm = new FormGroup({
    concurso: new FormControl<ConcursosAtivos | null>(null),
    papel: new FormControl(''),
    nome: new FormControl(''),
  })

  concursosAtivos$: Observable<ConcursosAtivos[]> = from([])
  concursosAtivos: ConcursosAtivos[] = []

  private destroy$ = new Subject<void>()

  constructor(private readonly comissaoJulgadoraService: ComissaoJulgadoraService) {}

  ngOnChanges() {
    // Update form when initialFilters change
    this.filterForm.patchValue(
      {
        papel: this.initialFilters.papel,
        nome: this.initialFilters.nome,
      },
      { emitEvent: false }
    )
  }

  ngOnInit() {
    this.comissaoJulgadoraService.buscarConcursosAtivos().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(resp => {
      this.concursosAtivos = resp
      const concurso = this.concursosAtivos.find(({ id: concursoId }) => concursoId === this.initialFilters.concurso)
      if (concurso) {
        this.filterForm.patchValue({ concurso })
      }
    })

    this.filterForm
      .get('concurso')!
      .valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged())
      // TODO: Arrumar no componente de autocomplete. concurso: valor
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(valor => this.emitFilters({ concurso: valor?.id || undefined }))

    this.filterForm
      .get('papel')!
      .valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(valor => this.emitFilters({ papel: valor || undefined }))

    this.filterForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(valor => logger.log(valor))
  }

  handleEnterKey() {
    const valor = this.filterForm.value.nome
    this.emitFilters({ nome: valor || undefined })
  }

  handleClearSearchInput() {
    this.filterForm.patchValue({ nome: undefined })
    this.emitFilters({ nome: undefined })
  }

  private emitFilters(filtro: ExaminadoresFiltro) {
    this.filterChanged.emit(filtro)
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
